export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/gamification/times-table-competition-2021/second-place.png'
